import React from "react";
import { Link } from "react-router-dom";
import { HardHat, Users, GraduationCap, ArrowRight, Sparkles } from "lucide-react";

/**
 * Compact Impact band for HomePage / InvestorsPage.
 * Uses the official ratios (£10k = 3–5 jobs, £25k = 1 plot, 40% local reservation).
 */
export default function ImpactBand() {
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="impact-band"
             style={{ background: "linear-gradient(180deg, #fff, rgba(212,175,55,0.06))" }}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Impact</span></div>
            <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
              Your money, doing <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>double work.</span>
            </h2>
            <p className="mt-4 text-[15px]" style={{ color: "var(--mv-muted)" }}>
              Every <strong>£10,000</strong> you invest creates ~<strong>3–5 sustainable local jobs</strong>.
              Every home built supports <strong>7+ local livelihoods</strong> for years to come.
            </p>
            <ul className="mt-6 space-y-2 text-[14px]" style={{ color: "var(--mv-ink)" }}>
              <li className="flex items-start gap-2"><Sparkles size={16} className="mt-0.5 mv-green-text"/>60% of entry roles reserved for youth &amp; women.</li>
              <li className="flex items-start gap-2"><Sparkles size={16} className="mt-0.5 mv-green-text"/>80% of jobs go to people living locally.</li>
              <li className="flex items-start gap-2"><Sparkles size={16} className="mt-0.5 mv-green-text"/>Free certified Pula Learn training for every worker.</li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/impact" className="btn-green" data-testid="impact-band-cta">
                See phase plan &amp; calculator <ArrowRight size={15}/>
              </Link>
              <Link to="/investors" className="btn-ghost" data-testid="impact-band-invest">
                Invest with impact
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <BandCard icon={<HardHat size={20}/>} n="610–980" l="Phase 1 jobs (2–3 yrs)"/>
            <BandCard icon={<HardHat size={20}/>} n="4.3k–9.2k" l="Phase 2 jobs (5 yrs)"/>
            <BandCard icon={<Users size={20}/>} n="200–500" l="local agent roles"/>
            <BandCard icon={<GraduationCap size={20}/>} n="Free" l="Pula Learn training"/>
          </div>
        </div>
      </div>
    </section>
  );
}

function BandCard({ icon, n, l }) {
  return (
    <div className="mv-card p-5">
      <div className="w-10 h-10 rounded-2xl flex items-center justify-center mb-3 mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{icon}</div>
      <div className="font-display text-2xl mv-green-text">{n}</div>
      <div className="text-[11.5px] mt-0.5" style={{ color: "var(--mv-muted)" }}>{l}</div>
    </div>
  );
}
